class ProgressBar {
  constructor(totalSteps = 10, elementId = "progressFill") {
    this.totalSteps = totalSteps;
    this.elementId = elementId;
    this.progressElement = null;
    this.sliderItems = document.querySelectorAll("#slider .item-slider");
    this.initNavigation();

    if (typeof HorizontalScroller !== "undefined") {
      this.scroller = new HorizontalScroller(
        "slider",
        ".left-arrow",
        ".right-arrow",
      );
    } else {
      console.warn(
        "HorizontalScroller-Klasse nicht gefunden. Scroll-Pfeile sind nicht funktionsfähig.",
      );
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.progressElement = document.getElementById(this.elementId);
    if (!this.progressElement) {
      console.warn(
        `Progress bar element with ID '${this.elementId}' not found`,
      );
    }
  }

  setProgress(percentage) {
    if (this.progressElement) {
      this.progressElement.style.width = percentage + "%";
    }
  }

  setStep(step) {
    if (step < 0) step = 0;
    if (step > this.totalSteps) step = this.totalSteps;

    const percentage = Math.round((step / this.totalSteps) * 100);

    this.sliderItems.forEach((item, index) => {
      if (index === step - 1) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });

    this.scrollToActiveItem();

    this.setProgress(percentage);
  }

  initNavigation() {
    const configuratorSteps = [
      "/pages/bsbc_serie_01", // 1. Serie
      "/pages/bsbc_size_02", // 2. Größe
      "/pages/bsbc_headboard_03", // 3. Headboard
      "/pages/bsbc_color_04", // 4. Farbe
      "/pages/bsbc_box_05", // 5. Box
      "/pages/bsbc_feet_06", // 6. Füße
      "/pages/bsbc_topper_07", // 7. Topper
      "/pages/bsbc_matress_08", // 8. Matratze
      "/pages/bsbc_upgrades_09", // 9. Upgrades
      "/pages/bsbc_final_11", // 10. Fertig
    ];

    if (configuratorSteps.length !== this.sliderItems.length) {
      console.error(
        "Fehler: Die Anzahl der übergebenen URLs stimmt nicht mit der Anzahl der Schritte überein.",
      );
      return;
    }

    this.sliderItems.forEach((item, index) => {
      const urlPath = configuratorSteps[index];
      item.addEventListener("click", () => {
        GlobalGeneric.go(GlobalGeneric.addCurrentParams(urlPath));
      });
      item.style.cursor = "pointer";
    });
  }

  scrollToActiveItem() {
    const sliderContainer = document.getElementById("slider");
    const activeItem = sliderContainer.querySelector(".item-slider.active");

    if (sliderContainer && activeItem) {
      const itemOffset = activeItem.offsetLeft;
      const sliderWidth = sliderContainer.clientWidth;
      const itemWidth = activeItem.offsetWidth;

      const scrollPosition = itemOffset - sliderWidth / 2 + itemWidth / 2;

      sliderContainer.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
    }
  }

  resetSteps() {
    this.setStep(0);
  }
}
